import axios from "axios";
    
    const estoreBaseUrl = process.env.VUE_APP_API_URL_ESTORE;

    const httpClient = axios.create({
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 120000
    });

    httpClient.interceptors.response.use(
      response => response,
      error => errorInterceptor(error)
    );

    const errorInterceptor = error => {
      if (error && !error.response) {
        if (error.code === "ECONNABORTED") {
          error.response = {
            data: {
              isSucess: false,
              errors: {
                Files: [
                  "Request has timed out. Please try again, if issue persists then call our support team"
                ]
              }
            }
          };
        }
      }
      return Promise.reject(error);
    };

   export default {
      healthCheck() {
        return httpClient.get(estoreBaseUrl);
      },
      fetchProductDetails(classId) {
        return httpClient.get(`${estoreBaseUrl}product-class/${classId}`);
      },
      getPurchaseOrderSummary(params) {
         return httpClient.post(`${estoreBaseUrl}orders/order-summary`, params);
      },
      postGenericProductApi: params => {
        return httpClient.post(
          `${estoreBaseUrl}orders/add-generic-product-order`,
          params
        );
      },
      getOrderDetails: orderId => {
        return httpClient.get(`${estoreBaseUrl}orders/${orderId}`);
      },
   };